<template>
  <div class="about_organ">
    <div class="cont_list_cont ql-editor" v-html="detail.content"></div>
  </div>
</template>

<script>
export default {
  name: 'companyTeam',
  data(){
    return{
      detail: "",
      id: ""
    }
  },
  mounted: function(){
    var _this = this

    _this.getData()
  },
  methods: {
    async getData() {
      var _this = this;
      var {data} = await _this.$http.post(_this.apiUrl + "/getNewsList", { page: 1, classification: 6});
      _this.id = data.data.list[0].id;
      var detailAll = await _this.$http.post(_this.apiUrl + "/getNewsDetail", { id: _this.id});
      var detail = detailAll.data;
      _this.detail = detail.data;
    },

  }
}
</script>